
































































































































import Vue from 'vue'
import { Component, Prop } from 'vue-property-decorator'
import ChartProgress from './ChartProgress.vue'
import ExamSkillReport from './ExamSkillReport.vue'
import ExamSkillItemReport from './ExamSkillItemReport.vue'
import ExamResultQuestionGroupList from './ExamResultQuestionGroupList.vue'
import { ROUTER_NAME } from '../../router'
import Exam from '../../models/exam'
import { LETTER_FORMAT } from '../../utils/constants'
import { GroupQuestion } from '../../../api/v2/models/question'
import FbShareButton from './FbShareButton.vue'
import TwShareButton from './TwShareButton.vue'
import { headerState } from '../../stores/header'
import { footerState } from '../../stores/footer'
import UserExam from '../../models/user_exam'
import { ExamQScoreHistory } from '../../../api/v2/models/q_score_history'
import ExamEvaluationComponent from './ExamEvaluation.vue'
import SkillsChart from "./SkillsChart.vue";
import Banner from "../../../api/v2/models/banner";

@Component({
  components: {
    SkillsChart,
    ChartProgress,
    ExamSkillReport,
    ExamSkillItemReport,
    ExamResultQuestionGroupList,
    FbShareButton,
    TwShareButton,
    ExamEvaluationComponent,
  }
})
export default class ExamResultMobile extends Vue {
  @Prop({ required: true }) exam!: Exam
  @Prop({ required: true }) userExam!: UserExam
  @Prop({ required: true }) groupQuestions!: GroupQuestion[]
  @Prop({required: false}) banners!: Banner[]

  @Prop({ default: null })
  examQScoreHistory!: ExamQScoreHistory | null

  LETTER_FORMAT = LETTER_FORMAT
  active = 0

  get skills() {
    return this.exam.examSkills
  }

  get shareUrl() {
    return `${window.location.origin}/exams/${this.exam.id}`
  }

  get shareText() {
    return `
    ${this.userExam.passed ? '合格しました！' : '残念ながら不合格です'}
    正解率: ${this.userExam.average}%\n
    平均: ${this.exam.averageRate}%\n
    順位: ${this.userExam.position}位\n
    `
  }

  getQuestionNumber(groupExamResultQuestion) {
    return (
      this.groupQuestions
        .filter((item) => item.questions.every((question) => !question.isDescriptionQuestion))
        .indexOf(groupExamResultQuestion) + 1
    )
  }

  public mounted() {
    footerState.setFooterDefault()
  }

  getBanner(position) {
    var result = this.banners.find((banner) => {
      return banner.position == position
    })
    return result
  }

}
